import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* Constellation Imports */
import { SpinnerModule } from '@vg-constellation/angular-13/spinner';
import { ModalDialogModule } from '@vg-constellation/angular-18/modal-dialog';
import { BannerModule } from '@vg-constellation/angular-13/banner';
import { LinkModule } from '@vg-constellation/angular-13/link';
import { RadioModule } from '@vg-constellation/angular-18/radio';
import { SelectModule } from '@vg-constellation/angular-13/select';
import { InputModule } from '@vg-constellation/angular-13/input';
import { WindowRef } from './services/window-ref/window-ref.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { PortfolioDataService } from './services/portfolio-data-service/portfolio-data.service';
import { AlertsHelperService } from './services/alerts-helper/alerts-helper.service';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@vg-constellation/angular-13/icon';
import { AccordionModule } from '@vg-constellation/angular-13/accordion';
import { environment } from 'src/environments/environment';
import { ButtonModule } from '@vg-constellation/angular-13/button';
import { CardModule } from '@vg-constellation/angular-13/card';
import { DrawerModule } from '@vanguard/pfx-components';
import { AdobeAnalyticsService } from './services/adobe-analytics/adobe-analytics.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DrawerModule as ConstellationDrawerModule } from '@vg-constellation/angular-13/drawer';
import { TabsModule } from '@vg-constellation/angular-18/tabs';
import { ChipModule } from '@vg-constellation/angular-18/chip';
import { GaugeCardComponent } from './components/portfolio-health-check/gauge-card/gauge-card.component';
import { GaugeComponent } from './components/portfolio-health-check/gauge/gauge.component';
import { BalanceComponent } from './components/portfolio-health-check/image/balance/balance.component';
import { UserCashComponent } from './components/portfolio-health-check/image/user-cash/user-cash.component';
import { ManWithDogComponent } from './components/portfolio-health-check/image/man-with-dog/man-with-dog.component';
import { ContributingComponent } from './components/portfolio-health-check/image/contribuiting/contributing.component';
import { TradingSellComponent } from './components/portfolio-health-check/image/trading-sell/trading-sell.component';
import { CashPaymentComponent } from './components/portfolio-health-check/image/cash-payment/cash-payment.component';
import { FactorLineComponent } from './components/portfolio-health-check/factor-line/factor-line.component';
import { FactorCardComponent } from './components/portfolio-health-check/factor-card/factor-card.component';
import { MeterIllustrationComponent } from './components/portfolio-health-check/image/meter-illustration/meter-illustration.component';
import { TakeActionBannerComponent } from './components/portfolio-health-check/image/take-action-banner/take-action-banner.component';
import { AlignedChipComponent } from './components/portfolio-health-check/aligned-chip/aligned-chip.component';
import { AlignedCardComponent } from './components/portfolio-health-check/aligned-card/aligned-card.component';
import { DisclosureBoxComponent } from './components/portfolio-health-check/disclosure-box/disclosure-box.component';
import { SellAccordionComponent } from './components/portfolio-health-check/make-a-plan/sell-accordion/sell-accordion.component';
import { UseAvailableCashAccordionComponent } from './components/portfolio-health-check/make-a-plan/use-available-cash-accordion/use-available-cash-accordion.component';
import { ContributeAccordionComponent } from './components/portfolio-health-check/make-a-plan/contribute-accordion/contribute-accordion.component';
import { PageHelpComponent } from './components/page-help/page-help.component';
import { PageHelpParserComponent } from './components/page-help/page-help-parser/page-help-parser.component';
import { PageHelpCardComponent } from './components/page-help/page-help-card/page-help-card.component';
import { PortfolioHealthCheckComponent } from './components/portfolio-health-check/portfolio-health-check.component';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { ContentDirective } from './directives/content/content.directive';
import { AdobeExperienceManagerService } from './services/adobe-experience-manager/adobe-experience-manager.service';
import { ChannelBrokerService } from './services/channel-broker/channel-broker.service';
import { SecureSiteHeaderContainerComponent } from './components/secure-site-header-container/secure-site-header-container.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { CookieService } from 'ngx-cookie-service';
import { SvgSpriteService } from './services/svg-icons/svg-icons.service';
import { RebalancingYourPortfolioComponent } from './components/portfolio-health-check/rebalancing-your-portfolio/rebalancing-your-portfolio.component';
import { NoGoalsComponent } from './components/portfolio-health-check/no-goals/no-goals.component';
import { AccordionComponent } from './components/portfolio-health-check/accordion/accordion.component';
import { FailureCardComponent } from './components/failure-card/failure-card.component';
import { SafeHtmlPipe } from './pipes/safe-html/safe-html.pipe';
import { FormsModule } from '@angular/forms';
import { StackedBarChartComponent } from './components/portfolio-health-check/stacked-bar-chart/stacked-bar-chart.component';
import { AnalysisWarningCardComponent } from './components/portfolio-health-check/analysis-warning-card/analysis-warning-card.component';
import { RangeChartComponent } from './components/portfolio-health-check/range-chart/range-chart.component';

@NgModule({
  declarations: [
    AppComponent,

    // Portfolio Health Check
    PortfolioHealthCheckComponent,
    GaugeCardComponent,
    GaugeComponent,
    BalanceComponent,
    UserCashComponent,
    ManWithDogComponent,
    ContributingComponent,
    TradingSellComponent,
    CashPaymentComponent,
    FactorLineComponent,
    FactorCardComponent,
    MeterIllustrationComponent,
    TakeActionBannerComponent,
    AlignedChipComponent,
    AlignedCardComponent,
    DisclosureBoxComponent,
    SellAccordionComponent,
    UseAvailableCashAccordionComponent,
    ContributeAccordionComponent,
    PageHelpComponent,
    PageHelpParserComponent,
    PageHelpCardComponent,
    ContentDirective,
    SecureSiteHeaderContainerComponent,
    AppHeaderComponent,
    RebalancingYourPortfolioComponent,
    NoGoalsComponent,
    AccordionComponent,
    FailureCardComponent,
    StackedBarChartComponent,
    AnalysisWarningCardComponent,
    RangeChartComponent,
    SafeHtmlPipe,
  ],
  imports: [
    AppRoutingModule,
    SharedPipesModule,
    BrowserModule,
    ConstellationDrawerModule,
    HttpClientModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,

    // c11n v13 modules
    IconModule,
    ModalDialogModule.forRoot(),
    SpinnerModule,
    LinkModule,
    BannerModule,
    RadioModule,
    SelectModule,
    InputModule,
    ButtonModule,
    AccordionModule,
    CardModule,

    //c11n v18 modules
    TabsModule,
    ChipModule,

    // pfx-components modules
    DrawerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AlertsHelperService,
    PortfolioDataService,
    AdobeAnalyticsService,
    WindowRef,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: function (
        http: HttpClient,
        meta: Meta,
        windowRef: WindowRef,
        aem: AdobeExperienceManagerService,
        cb: ChannelBrokerService,
      ) {
        const $window: Window = windowRef.nativeWindow;

        return async () => {
          await http
            .get(`${environment.CONSUMER_API}adobe`, { withCredentials: true })
            .toPromise()
            .then((data: any) => {
              const spoid = data.sPOID;
              meta.updateTag({ name: 'DCSext.poid', content: data.poid });
              meta.updateTag({ name: 'DCSext.sPoid', content: spoid }); // Used for Floodlight
              meta.updateTag({ name: 'WT.seg_6', content: data.crewFlag });
              $window.document.body.hidden = false;
            })
            .catch(() => {
              if (environment.EXTERNAL === true) {
                $window.document.location.href = environment.LOGON_URL;
                return Promise.reject();
              } else {
                $window.document.body.hidden = false;
                return true;
              }
            });

          await Promise.all([aem.setUpAEM(), cb.validateUserChannelBroker()]).then(() => {
            console.log('AEM data fetched successfully and Channel Broker data fetched successfully');
          });
        };
      },
      deps: [HttpClient, Meta, WindowRef, AdobeExperienceManagerService, ChannelBrokerService, CookieService, SvgSpriteService],
    },
  ],
  bootstrap: [AppComponent],
  exports: [SafeHtmlPipe]
})
export class AppModule { }
